angular.module('eatself').component('productDescription', {
	bindings: {
		description: '<',
		maxLength: '<',
	},
	controllerAs: 'vm',
	template: `
	<p>
		{{vm.description|truncate:vm.maxLength:''}}
		<span ng-if="vm.description.length > vm.maxLength">...</span>
	</p>
	`
})